import { Clock, Target, BookOpen, Lock } from 'lucide-react';

const benefits = [
  {
    icon: Clock,
    title: 'Gagnez du temps',
    description: 'Identifiez rapidement les dossiers pertinents et évitez de perdre des mois sur un projet inadapté.',
  },
  {
    icon: Target,
    title: 'Décision structurée',
    description: 'Score global + recommandations actionnables pour une prise de décision éclairée.',
  },
  {
    icon: BookOpen,
    title: 'Simple & pédagogique',
    description: 'Pas besoin d\'être expert financier. L\'analyse est claire et accessible.',
  },
  {
    icon: Lock,
    title: 'Confidentialité',
    description: 'Vos données sont privées et sécurisées. Aucun partage avec des tiers.',
  },
];

export function WhyRepriScanSection() {
  return (
    <section className="py-16 md:py-24 bg-muted/30">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Pourquoi RepriScan ?
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Un outil conçu par et pour des repreneurs qui veulent aller à l'essentiel.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="flex gap-4 p-6 bg-card rounded-xl border hover:shadow-md transition-shadow"
            >
              <div className="shrink-0">
                <div className="w-12 h-12 rounded-lg bg-accent/10 flex items-center justify-center">
                  <benefit.icon className="h-6 w-6 text-accent" />
                </div>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">{benefit.title}</h3>
                <p className="text-sm text-muted-foreground">{benefit.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
